import { render, staticRenderFns } from "./realCallDuration.vue?vue&type=template&id=83587be0&scoped=true"
import script from "./realCallDuration.vue?vue&type=script&lang=js"
export * from "./realCallDuration.vue?vue&type=script&lang=js"
import style0 from "./realCallDuration.vue?vue&type=style&index=0&id=83587be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83587be0",
  null
  
)

export default component.exports